import appconfig from '@/utils/appConfig';
import classNames from 'classnames';

type Props = {
    itemsLength: number;
    selectedIndex: number;
};
const Dots = ({ itemsLength, selectedIndex }: Props) => {
    const arr = new Array(itemsLength).fill(0);
    return (
        <div className="flex gap-1 my-2 justify-center mb-4 w-full">
            {arr.map((_, index) => {
                const selected = index === selectedIndex;
                return (
                    <div
                        className={`${classNames({
                            'h-2 w-2 rounded-full transition-all duration-300':
                                true,
                            // tune down the opacity if slide is not selected
                            'opacity-50': !selected,
                        })} ${appconfig.colors.coloredSection}`}
                        key={index}
                    ></div>
                );
            })}
        </div>
    );
};
export default Dots;
